<template>
  <v-container>
    <v-row>
      <v-col cols="6">
        <h2>Organisationen</h2>
      </v-col>
      <v-col cols="6" class="text-right">
        <v-btn
          color="primary"
          :to="{ name: 'kige-organization-merge' }"
        >
          <v-icon left>mdi-merge</v-icon>
          Zusammenführen / Neu anlegen
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="search"
          label="Suche"
          clearable
          dense
          outlined
          class="mb-4"
          prepend-inner-icon="mdi-magnify"
        ></v-text-field>
        <v-data-table
          :headers="headers"
          :items="organizations"
          :search="search"
          @click:row="goToDetail"
          class="elevation-1"
          style="cursor: pointer"
        >
          <template #item.valid_from="{ item }">
            {{ item.valid_from | formatDate }}
          </template>
          <template #item.valid_before="{ item }">
            {{ item.valid_before | formatDate }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// FIXME AI
import { GET_ORGANIZATIONS } from '@/modules/kirchgeld/store/kirchgeld/action-types'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'OrganizationList',
  data () {
    return {
      search: '',
    }
  },
  computed: {
    ...mapState('kirchgeld', ['organizations']),
    headers () {
      return [
        { text: 'Name', value: 'name' },
        { text: 'KRO', value: 'kro_nr' },
        { text: 'Externe ID', value: 'external_id' },
        { text: 'Gültig von', value: 'valid_from' },
        { text: 'Gültig bis', value: 'valid_before' },
      ]
    }
  },
  filters: {
    formatDate (value) {
      if (!value) return '-'
      return moment(value).format('DD.MM.YYYY')
    }
  },
  async mounted () {
    await this.$store.dispatch('kirchgeld/' + GET_ORGANIZATIONS)
  },
  methods: {
    goToDetail (item) {
      const id = item.url.split('/').filter(Boolean).pop()
      this.$router.push({
        name: 'kige-organization-detail',
        params: { 'organization-id': id }
      })
    }
  }
}
</script>

<style scoped>
</style>
